import script from "./UserProfileForm.vue?vue&type=script&setup=true&lang=js"
export * from "./UserProfileForm.vue?vue&type=script&setup=true&lang=js"

import "./UserProfileForm.vue?vue&type=style&index=0&id=4dd60cdc&lang=scss&scoped=true"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-4dd60cdc"]])

export default __exports__